import * as z from "zod";
import type { TFunction } from "i18next";

const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const createDocumentSchema = (t: TFunction) =>
  z.object({
    file: z
      .array(z.any())
      .min(1, t("management.termsOfUse.validation.fileRequired"))
      .refine(
        (file) => !file[0] || file[0].size <= MAX_FILE_SIZE,
        t("management.termsOfUse.validation.fileTooLarge"),
      )
      .refine(
        (file) => !file[0] || file[0].type === "application/pdf",
        t("management.termsOfUse.validation.fileInvalidType"),
      ),
  });

export type DocumentUploadFormData = z.infer<
  ReturnType<typeof createDocumentSchema>
>;
